// 首页编委会展示遍历姓氏
export const HOME_COMMITTEE_SURNAME_LIST = ["赵", "王", "张"]


// 通知类型
export const NOTICE_TYPE = {
  // "通知详情"
  NOTICE: 1,
  // "企业详情"
  ENTERPRISE: 2,
  // "轮播图详情"
  SLIDER: 3,
}

export const PORT_TYPE_CODE = {
  APP_ZTGL_DL: "APP_ZTGL_DL",//今日活跃用户
  APP_ZTGL_XZ: "APP_ZTGL_XZ",//今日新增用户

  APP_GKLM_BJX: "APP_GKLM_BJX",//百家姓
  APP_GKLM_XQWZ: "APP_GKLM_XQWZ",//寻亲问祖
  APP_GKLM_WNL: "APP_GKLM_WNL",//万年历
  APP_GKLM_QM: "APP_GKLM_QM",//起名
  APP_GKLM_YS: "APP_GKLM_YS",//运势
  APP_GKLM_JPK: "APP_GKLM_JPK",//家谱库
  APP_GKLM_WHJT: "APP_GKLM_WHJT",//文化讲堂
  APP_GKLM_KF: "APP_GKLM_KF",//客服
  APP_GKLM_DJXX: "APP_GKLM_DJXX",//党建学习

  APP_BWHLM_TZ: "APP_BWHLM_TZ",//通知
  APP_BWHLM_ZZ: "APP_BWHLM_ZZ",//组织
  APP_BWHLM_CPJ: "APP_BWHLM_CPJ",//长谱节
  APP_BWHLM_QY: "APP_BWHLM_QY",//企业
  APP_BWHLM_JP: "APP_BWHLM_JP",//家谱
  APP_BWHLM_JPS: "APP_BWHLM_JPS",//家谱树
  APP_BWHLM_WDZX: "APP_BWHLM_WDZX",//我的直系
  APP_BWHLM_QYJL: "APP_BWHLM_QYJL",//迁移记录
  APP_BWHLM_ZB: "APP_BWHLM_ZB",//字辈
  APP_BWHLM_RD: "APP_BWHLM_RD",//人丁
  APP_BWHLM_SR: "APP_BWHLM_SR",//生日
  APP_BWHLM_WH: "APP_BWHLM_WH",//文化
  APP_BWHLM_XC: "APP_BWHLM_XC",//相册
  APP_BWHLM_QF: "APP_BWHLM_QF",//祈福
  APP_BWHLM_ZFPHB: "APP_BWHLM_ZFPHB",//祝福排行榜
  APP_BWHLM_JZQ: "APP_BWHLM_JZQ",//家族圈

  DESKTOP_ZT_FW: "DESKTOP_ZT_FW",//访问次数
  DESKTOP_ZT_XZ: "DESKTOP_ZT_XZ",//新增成员

  PC_ZTGL_FW: "PC_ZTGL_FW", //访问次数
  PC_LMFW_BJX: "PC_LMFW_BJX", //百家姓  
  PC_LMFW_XQWZ: "PC_LMFW_XQWZ", //寻亲问祖  
  PC_LMFW_JPK: "PC_LMFW_JPK", //家谱库
  PC_LMFW_DJXX: "PC_LMFW_DJXX", //党建学习  
  PC_LMFW_XZZX: "PC_LMFW_XZZX", //下载中心
  PC_LMFW_GYWM: "PC_LMFW_GYWM", //关于我们
}
